import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StepsModule } from 'primeng/steps';
import { ButtonModule } from 'primeng/button';
import { GenericButtonComponent } from "../../../global/component/generic/generic-button/generic-button.component";
import { GenericTextInputComponent } from '../../../global/component/generic/generic-text-input/generic-text-input.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Stepper, StepperModule } from 'primeng/stepper';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { EventModalComponent } from '../../shared-components/event-modal/event-modal.component';
import { FundraiserModalComponent } from '../../shared-components/fundraiser-modal/fundraiser-modal.component';
import { AddDonationService } from '../../services/add-donation.service';
import { Subscription, catchError, debounceTime, distinctUntilChanged } from 'rxjs';
import { AutocompleteService } from '../../services/autocomplete.service';
import { EntityType } from '../../models/ConstantsAndEnums';
import { autocompleteSelectionValidator } from '../../validators/non-async-validators';
import { DonorSearchComponent } from '../donor-search/donor-search.component';
import { SearchService } from '../../../global/services/data/search-service/searchservice';
import { DonorAddComponent } from '../donor-add/donor-add.component';
import { DonorDedupeComponent } from '../donor-dedupe/donor-dedupe.component';
import { DedupeDonor } from '../../models/AddDonationModels';
import { DonorFundTotalsGridComponent } from '../../shared-components/donor-fund-totals-grid/donor-fund-totals-grid.component';
import { DonationBatchHeaderComponent } from './donation-batch-header/donation-batch-header.component';
import { AddDonationBatchHeaderModel } from '../../models/AddDonationBatchHeaderModel';
import { ActivatedRoute, Router } from '@angular/router';
import { BatchService } from '../../services/donation-batch.service';
import { MainModel } from "../../../global/model/MainModel";
import Campaign from "../../../global/model/Campaign";
import { restrictToTwoDecimals } from '../../../global/util/util';
import { DonorType } from '../../models/ConstantsAndEnums';
import { DonationFlagModalComponent } from '../../shared-components/donation-flag-modal/donation-flag-modal.component';
import { DonationFlagsService } from '../../services/donation-flags.service';
import { CampaignPageEnum, FeatureAccess } from "../../../global/model/CampaignFeature";
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-donations-add',
  standalone: true,
  
  imports: [
    EventModalComponent,
    FundraiserModalComponent,
    DonorDedupeComponent,
    DonorSearchComponent,
    DonorAddComponent,
    DonorFundTotalsGridComponent,
    CommonModule,
    ReactiveFormsModule,
    StepsModule,
    StepperModule,
    ButtonModule,
    GenericButtonComponent,
    GenericTextInputComponent,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    CalendarModule,
    CheckboxModule,
    TableModule,
    AutoCompleteModule,
    ToastModule,
    ConfirmDialogModule,
    DialogModule,
    CardModule,
    DonationBatchHeaderComponent,
    DonationFlagModalComponent,
    MessageModule
  ],
  providers: [
    ConfirmationService,
    MessageService,
    AddDonationService,
    AutocompleteService,
    DonationFlagsService
  ],
  templateUrl: './donations-add.component.html',
  styleUrl: './donations-add.component.scss'
})
export class DonationsAddComponent implements OnInit, OnDestroy {
  @ViewChild('addDonationStepper') addDonationStepper!: Stepper;
  donationForm: FormGroup;
  activeIndex = 0; 
  campaignId: number = -1;
  donorName: string | null = null;
  donorId: string | null = null;
  donorCity: string | null = null;
  donorState: string | null = null;
  navigationSource: string | null = null;
  routeDonorId: string | null = null;
  donorDisplayInfo: string = '';
  isReadOnlyMode: boolean = false;

  steps = [
    { label: 'Donor' },
    { label: 'Donation Amount' },
    { label: 'Donation Attributes' },
  ];

  showDonorSearchDialog: boolean = false;
  showDonorInfo: boolean = false;
  selectedDonor: any;
  dedupeDonors: DedupeDonor[] = []
  selectedDonorGivingHistoryDonorId: string = '';
  subscription: Subscription = new Subscription();
  showAddNewDonorDialog: boolean = false;
  showDonorDedupeDialog: boolean = false;
  showDonorGivingHistoryDialog: boolean = false;

  // Autocompletes
  fundCodeSuggestions: any = [];
  eventCodeSuggestions: any = [];
  fundraiserSuggestions: any = [];
  parentDonationNameSuggestions: any = [];
  donationFlagSuggestions: any[] = [];

  // Dropdowns
  selectedFundraisers: any = [];
  contributionSourceOptions: any = [];
  contributionTypeOptions: any = [];
  fecLineOptions: any = [];
  eventTypes: any = [];
  states: any = [];
  parentChildOptions = [
    { label: 'Please Select', value: '' },
    { label: 'Child Donation', value: 'Child' },
    { label: 'Parent Donation', value: 'Parent' },
  ];
  parentDonationTypeOptions: any = [];
  //parentDonorDonationsOptions: any = [{ label: 'Number 1', value: '1' }];
  parentDonorDonationsOptions: any = [];
  addEventDisplayModal = false;
  addFundraiserDisplayModal = false;
  isChildDonation = false;
  isParentDonation = false;
  showPacLimitNotAffected = false;

  // Track lock status of fields
  fieldLockStatus: { [key: string]: boolean } = {
    amount: false,
    date: false,
    fundCode: false,
    contributionSourceId: false,
    contributionTypeId: false,
    eventCode: false,
    fundraiser: false,
    fecLineNumberId: false,
    transferTypeId: false,
    parentDonationName: false,
    parentDonationNumber: false,
    donationFlag: false
  };

  showHeader = false;
  headerModel!: AddDonationBatchHeaderModel;
  batchId  = null;

  showDonationFlagModal = false;
  isEditDonationFlag = false;
  selectedDonationFlag: any = null;
  selectedDonationFlags: any[] = [];
  pageAccess: FeatureAccess = 2;

  constructor(private fb: FormBuilder,
                private messageService: MessageService,
                private addDonationService: AddDonationService,
                private autoCompleteService: AutocompleteService,
                private searchService: SearchService,
                private confirmationService: ConfirmationService,
                private route: ActivatedRoute,
                private batchService: BatchService,
                private router: Router,
                private mainModel: MainModel
  ) {
    this.donationForm = this.fb.group({
      batchId: [null],
      campaignId: [this.campaignId, Validators.required],
      donorId: [this.donorId, Validators.required],
      amount: ['', [Validators.required, Validators.min(1)]],
      date: ['', Validators.required],
      pledged: [false],
      fundCode: ['', [Validators.required, autocompleteSelectionValidator(() => this.fundCodeSuggestions)]],
      fundCodeId: ['', [Validators.required]],
      contributionSourceId: ['', Validators.required],
      contributionTypeId: ['', Validators.required],
      checkNumber: [''],
      eventCode: [''],
      eventCodeId: [''],
      fundraiser: [''],
      fundraiserIds: [[]],
      fecLineNumberId: ['', Validators.required],
      isMemo: [false],
      fecDescription: [''],
      memoText: [''],
      notes: [''],
      parentChildDonation: [''],
      isMasterDonation: [null],
      transferTypeId: [''],
      parentDonationName: [''],
      parentDonationId: [''],
      parentDonationNumber: [''],
      pacLimitNotAffected: [false],
      donationFlag: [''],
      donationFlagIds: [[]] 
    });

    this.setupConditionalValidation();

    this.fetchCampaignId();
  }

  private fetchCampaignId(): void {
    const selectedCampaignId = this.mainModel.userSelectedCampaignId;
    if (!selectedCampaignId) {
      this.mainModel.fetchSelectedCampaign().subscribe({
        next: (campaign: Campaign) => {
          //this.mainModel.setSelectedCampaign(campaign);
          this.campaignId = campaign.campaignId;
          this.donationForm.get('campaignId')?.setValue(this.campaignId);
          this.loadDonationLookups();
          this.populateDonorInfoFromQueryString();
          this.setDefaultFundCode();
          this.mainModel.fetchAndSetUserCampaignProductsFeaturesPages(campaign.campaignId).subscribe({
            next: (features) => {
              this.pageAccess = this.mainModel.userCampaignPageAccess(CampaignPageEnum.AddSingleDonation);
              this.isReadOnlyMode = (this.pageAccess === FeatureAccess.ReadOnly);
            },
            error: (err) => {
              console.error('Failed to fetch user campaign products features pages:', err);
            }
          });
          
        },
        error: (err) => {
          console.error('Failed to fetch selected campaign:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to fetch the selected campaign. Please try again later.',
            life: 5000,
          });
        },
      });
    } else {
      this.campaignId = selectedCampaignId;
      this.donationForm.get('campaignId')?.setValue(this.campaignId);
      this.loadDonationLookups();
      this.populateDonorInfoFromQueryString();
      this.setDefaultFundCode();
      this.pageAccess = this.mainModel.userCampaignPageAccess(CampaignPageEnum.DonationCard);
      this.isReadOnlyMode = (this.pageAccess === FeatureAccess.ReadOnly);
    }

    if (isNaN(this.campaignId as number)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid Campaign ID',
        detail: 'The selected campaign ID is invalid. Please select a valid campaign.',
        life: 5000,
      });
    }
  }

  private setDefaultFundCode(): void {
    this.addDonationService.getDefaultFundCodeForCampaign(this.campaignId).subscribe({
      next: (defaultFundCode: any) => {
        if (defaultFundCode) {
          const fundCodeControl = this.donationForm.get('fundCode');
          const fundCodeIdControl = this.donationForm.get('fundCodeId');

          // Temporarily disable the validator
          fundCodeControl?.clearValidators();

          fundCodeControl?.setValue({
            label: defaultFundCode.text,
            value: defaultFundCode.value
          });
          fundCodeIdControl?.setValue(defaultFundCode.value);

          // Clear validation errors
          fundCodeControl?.setErrors(null);
          fundCodeIdControl?.setErrors(null);

          // Reapply the validator after setting the default value
          this.fundCodeSuggestions = [{ label: defaultFundCode.text, value: defaultFundCode.value }];
          fundCodeControl?.setValidators([Validators.required, autocompleteSelectionValidator(() => this.fundCodeSuggestions)]);
          fundCodeControl?.updateValueAndValidity();
          fundCodeIdControl?.updateValueAndValidity();
        }
      },
      error: () => {
        // Optionally handle error
      }
    });
  }

  refreshBatchHeader() {
    if (this.batchId !== null) {
      this.batchService.getBatchedControls(this.batchId).subscribe({
        next: (response: any) => {
          this.headerModel = {
            campaign: response.campaignName,
            fundCode: response.fundcode,
            batchName: response.batchName,
            batchLink: `/vortex/donations/edit-donation-batch/${this.batchId}`,
            entered: response.existingBatchCount,
            amount: response.existingBatchAmount,
            remaining: response.totalBatchCount - response.existingBatchCount,
            remainingAmount: response.totalBatchAmount - response.existingBatchAmount
          }
          this.showHeader = true;
        },
        error: () => {
           this.messageService.add({ severity: 'error', summary: 'Failed to load donations' });
        },
        complete: () => {
          //this.loading = false;
        }
      });
    }
  }

  populateDonorInfoFromQueryString() {
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams['donorId']) {
      this.routeDonorId = queryParams['donorId'];
      this.donorId = this.routeDonorId;
      this.donationForm.get('donorId')?.setValue(this.donorId);

      const donorIdNum = Number(this.donorId);
      if (!isNaN(donorIdNum)) {
        this.addDonationService.getDonorInfo(donorIdNum, this.campaignId).subscribe({
          next: (data) => {
            if (data) {
              this.donorName = [
                data?.prefix,
                data?.firstName,
                data?.lastName,
                data?.suffix
              ].filter(Boolean).join(' ');
              this.donorCity = data?.city;
              this.donorState = data?.state;
              this.selectedDonor = data;
              this.showDonorInfo = true;

              if (
                data.donorTypeId === DonorType.Candidate ||
                data.donorTypeId === DonorType.Individual
              ) {
                this.donorDisplayInfo = [
                  data?.prefix,
                  data?.firstName,
                  data?.middleName,
                  data?.lastName,
                  data?.suffix
                ].filter(Boolean).join(' ');
              } else {
                this.donorDisplayInfo = data?.organization || '';
              }
            }
          }
        });
      }
    }

  }

  ngOnInit(): void {
    this.showDonorInfo = false;
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams['batchId']) {
      this.batchId = queryParams['batchId'];
      if (this.batchId) {
        this.donationForm.patchValue({ 'batchId': this.batchId });
      }
      this.refreshBatchHeader();
    }

    this.navigationSource = queryParams['source'] || null;

    if (this.campaignId && this.campaignId !== -1) {
      this.setDefaultFundCode();
    } else {
      const campaignIdSub = this.donationForm.get('campaignId')?.valueChanges.subscribe((cid) => {
        if (cid && cid !== -1) {
          this.setDefaultFundCode();
          campaignIdSub?.unsubscribe();
        }
      });
    }

    this.subscription.add(
    this.searchService.donorSelected$
      .subscribe((donor) => {
        if (donor) {
          this.addDonationService.getDonorInfo(donor?.DonorID, this.campaignId).subscribe({
            next: (data) => {
              if (data) {
                console.debug('Donor received:', donor);
                this.donorId = data?.donorId;
                this.donationForm.get('donorId')?.setValue(this.donorId);
                this.donorName = [
                  data?.prefix,
                  data?.firstName,
                  data?.lastName,
                  data?.suffix
                ].filter(Boolean).join(' ');
                this.donorCity = data?.city;
                this.donorState = data?.state;
                this.selectedDonor = donor;
                this.showDonorSearchDialog = false;
                this.showDonorInfo = true;

                if (
                  data.donorTypeId === DonorType.Candidate ||
                  data.donorTypeId === DonorType.Individual
                ) {
                  this.donorDisplayInfo = [
                    data?.prefix,
                    data?.firstName,
                    data?.middleName,
                    data?.lastName,
                    data?.suffix
                  ].filter(Boolean).join(' ');
                } else {
                  this.donorDisplayInfo = data?.organization || '';
                }
              } else {
                this.showDonorSearchDialog = false;
                this.showDonorInfo = false;
              }
            }
          });
        }
      }));

    this.subscription.add(
      this.searchService.compareDonors$.subscribe((value) => {
        if (value) {
          console.debug(`Donor's Selected: ${value}`);
          this.showDonorSearchDialog = false;
          this.showDonorDedupeDialog = true;
          this.dedupeDonors = value;
        }
      }));

    this.subscription.add(
      this.searchService.closeCompareDonors$.subscribe((value) => {
        if (value) {
          this.showDonorSearchDialog = false;
          this.showDonorDedupeDialog = false;
        }
      }));


    this.subscription.add(
    this.searchService.addNewDonor$.subscribe((value) => {
      if (value) {
        this.showDonorSearchDialog = false;
        this.showAddNewDonorDialog = true;
      } 
    }));


    this.subscription.add(
    this.searchService.closeNewDonor$.subscribe((value) => {
      if (value) {
        this.showDonorSearchDialog = false;
        this.showAddNewDonorDialog = false;
      }
    }));

    this.subscription.add(
    this.searchService.showDonorsGivingHistory$.subscribe((value) => {
      if (value) {
        this.showDonorSearchDialog = false;
        this.showDonorGivingHistoryDialog = true;
        this.selectedDonorGivingHistoryDonorId = value;
      }
    }));

    this.subscription.add(
      this.searchService.closeShowDonorGivingCompareDonors$.subscribe((value) => {
        if (value) {
          this.showDonorSearchDialog = false;
          this.showDonorGivingHistoryDialog = false;
        }
      }));

    this.subscription.add(
      this.mainModel.campaignNotifier.subscribe((newCampaignId: number) => {
        if (newCampaignId && newCampaignId !== this.campaignId) {
          this.searchService.stopDonorSelectedEmission();
        }
      })
    );

    this.subscription.add(
      this.searchService.saveDonor$.subscribe((donor) => {
        if (donor) {
          this.donorId = donor?.donorId;
          this.donationForm.get('donorId')?.setValue(this.donorId);
          this.donorName = [
            donor?.prefix,
            donor?.firstName,
            donor?.lastName,
            donor?.suffix
          ].filter(Boolean).join(' ');
          const primaryAddress = donor?.addresses.find((a: any) => a.isPrimary === true);
          this.donorCity = primaryAddress?.city ?? '';
          this.donorState = primaryAddress?.state ?? '';
          this.selectedDonor = donor;
          this.showAddNewDonorDialog = false;
          this.showDonorInfo = true;
        }
      }));
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.searchService.stopDonorSelectedEmission();
    this.searchService.stopSaveDonorEmission();
  }

  setupConditionalValidation() {
    this.donationForm.get('parentChildDonation')?.valueChanges.subscribe((value) => {
      const transferTypeId = this.donationForm.get('transferTypeId');
      const parentDonationName = this.donationForm.get('parentDonationName');
      const parentDonationNumber = this.donationForm.get('parentDonationNumber');

      if (value === 'Parent') {
        transferTypeId?.setValidators(Validators.required);
        parentDonationName?.clearValidators();
        parentDonationNumber?.clearValidators();
      } else if (value === 'Child') {
        transferTypeId?.setValidators(Validators.required);
        parentDonationName?.setValidators(Validators.required);
        parentDonationNumber?.setValidators(Validators.required);
      } else {
        transferTypeId?.clearValidators();
        parentDonationName?.clearValidators();
        parentDonationNumber?.clearValidators();
      }

      // Update validators to ensure they take effect
      transferTypeId?.updateValueAndValidity();
      parentDonationName?.updateValueAndValidity();
      parentDonationNumber?.updateValueAndValidity();
    });
  }

  loadDonationLookups() {
    this.addDonationService.getAddDonationLookups(this.campaignId).subscribe({
      next: (data: any) => {
        if (data) {
          this.contributionSourceOptions = this.mapToLabelValue(data.contributionSources);
          this.contributionTypeOptions = this.mapToLabelValue(data.contributionTypes);
          this.fecLineOptions = this.mapToLabelValue(data.fecLineNumbers);
          this.eventTypes = this.mapToLabelValue(data.eventTypes);
          this.states = this.mapToLabelValue(data.states);
          this.parentDonationTypeOptions = this.mapToLabelValue(data.transferTypes);
        }
      },
      error: (err) => {
        console.error('Error loading donation lookups:', err);
      }
    });
  }

  private mapToLabelValue(items: any[]): { label: string, value: string }[] {
    return items?.map((item: any) => ({ label: item.text, value: item.value })) || [];
  }
  get fundraisersSelected(): boolean {
    return this.selectedFundraisers.length > 0;
  }
 
  searchEventCode(query: string): void {
    if (!query) {
      this.eventCodeSuggestions = [];
      return;
    }

    this.autoCompleteService.getAutoCompleteResults(query, EntityType.Events, this.campaignId).pipe(
                            debounceTime(300),
                            distinctUntilChanged(),
                            catchError(() => [])
                          ).subscribe((results) => {
                            this.eventCodeSuggestions = this.mapToLabelValue(results);
                          });
  }

  searchFundCode(query: string): void {
    if (!query) {
      this.fundCodeSuggestions = [];
      this.donationForm.get('fundCode')?.setErrors({ required: true });
      return;
    }

    this.autoCompleteService.getAutoCompleteResults(query, EntityType.FundCodes, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      this.fundCodeSuggestions = this.mapToLabelValue(results);
      const fundCodeControl = this.donationForm.get('fundCode');
      if (results.length === 0 && fundCodeControl?.value) {
        fundCodeControl?.setErrors({ invalidSelection: true }); 
      } else {
        fundCodeControl?.setErrors(null); 
      }
      fundCodeControl?.updateValueAndValidity();
    });
  }

  searchFundraisers(query: string): void {
    if (!query) {
      this.fundraiserSuggestions = [];
      return;
    }

    this.autoCompleteService.getAutoCompleteResults(query, EntityType.Fundraisers, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      this.fundraiserSuggestions = this.mapToLabelValue(results);
    });
  }

  searchParentDonationNames(query: string): void {
    if (!query) {
      this.parentDonationNameSuggestions = [];
      return;
    }

    this.autoCompleteService.getAutoCompleteResults(query, EntityType.ParentDonors, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      this.parentDonationNameSuggestions = this.mapToLabelValue(results);
    });
  }

  searchDonationFlags(query: string): void {
    if (!query) {
      this.donationFlagSuggestions = [];
      return;
    }

    this.addDonationService.searchFlags(query, this.campaignId).subscribe({
      next: (results) => {
        this.donationFlagSuggestions = results.map((flag: any) => ({
          label: flag.text,
          value: flag.value
        }));
      },
      error: (err) => {
        console.error('Error searching donation flags:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to search donation flags. Please try again.'
        });
      }
    });
  }

  showDonorSearch() {
    this.showDonorSearchDialog = true;
  }

  saveEvent() {
    this.addEventDisplayModal = false;
  }

  saveFundraiser(data: any) {
    console.debug(data);
    this.addFundraiserDisplayModal = false;
    this.selectedFundraisers.push(data);
    const existingFundraiserIds = this.selectedFundraisers.map((fund: any) => fund.fundraiserId);
    this.donationForm.get('fundraiserIds')?.setValue(existingFundraiserIds);
  }

  saveDonationFlag(data: any): void {
    console.debug(data);
    this.showDonationFlagModal = false;
    this.selectedDonationFlags.push(data);
    const existingFlagIds = this.selectedDonationFlags.map((flag: any) => flag.donationFlagId);
    this.donationForm.get('donationFlagIds')?.setValue(existingFlagIds);
  }

  stepChange = (step: number) => {
    console.debug(`Step Number: ${step}`);
    this.activeIndex = step;
  };

  onEventCodeSelect(event: any) {
    const eventId = event.value.value; 
    this.donationForm.get('eventCodeId')?.setValue(eventId);
  }

  onFundCodeSelect(fundcode: any) {
    const fundCodeId = fundcode.value.value;
    this.donationForm.get('fundCodeId')?.setValue(fundCodeId);
  }

  onFundraiserSelect(fundraiser: any) {
    //const fundraiserId = fundraiser.value.value;
    this.selectedFundraisers.push({ fundraiserName: fundraiser.value.label, fundraiserId: fundraiser.value.value })
    const existingFundraiserIds = this.selectedFundraisers.map((fund: any) => fund.fundraiserId);
    // const existingFundraiserIds = this.donationForm.get('selectedFundraiserIds')?.value;
    this.donationForm.get('fundraiser')?.setValue('');
    this.donationForm.get('fundraiserIds')?.setValue(existingFundraiserIds);
  }

  onParentDonorSelect(parentDonor: any): void {
    const parentDonorId = parentDonor.value.value;
    this.donationForm.get('parentDonationId')?.setValue(parentDonorId);
    if (parentDonorId) {
      this.addDonationService.getParentDonorDonations(parentDonorId).subscribe({
        next: (data) => {
          this.parentDonorDonationsOptions = this.mapToLabelValue(data);
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while getting parent donor donations!' });
        }
      });
    }
  }

  onDonationFlagSelect(flag: any): void {
    this.selectedDonationFlags.push({ name: flag.value.label, donationFlagId: flag.value.value });
    const existingFlagIds = this.selectedDonationFlags.map((flag: any) => flag.donationFlagId);
    this.donationForm.get('donationFlagIds')?.setValue(existingFlagIds);

    // Clear autocomplete input after selection
    this.donationForm.get('donationFlag')?.setValue('');
  }

  getInvalidControls(formGroup: FormGroup): string[] {
    const invalidControls: string[] = [];
    const controls = formGroup.controls;

    for (const name in controls) {
      if (controls[name].invalid) {
        invalidControls.push(name);
      }
    }

    return invalidControls;
  }

  validateSpecificControls(formGroup: FormGroup, controlNames: string[]): void {
    controlNames.forEach((controlName) => {
      const control = formGroup.get(controlName);
      if (control) {
        control.markAsTouched(); // Ensures validation messages are displayed
        control.updateValueAndValidity(); // Triggers validation for this control
      }
    });
  }

  hasCommonElement(array1: string[], array2: string[]): boolean {
    return array1.some(element => array2.includes(element));
  }

  hideDonorSearchDialog() {
    this.showDonorSearchDialog = false;
  }


  onStep2NextClick(): void {
    const step2ValidationControls = ['amount', 'date', 'fundCode', 'contributionSourceId', 'contributionTypeId'];

    this.validateSpecificControls(this.donationForm, step2ValidationControls);
    if (this.hasCommonElement(this.getInvalidControls(this.donationForm), step2ValidationControls)) {
      this.messageService.add({ severity: 'info', summary: 'Validation Error', detail: 'Please fix validation errors before continuing to next step!' });
    } else {
      this.addDonationStepper.activeStep = 2;
      this.activeIndex = 2;
    }
  }

  removeFundraiser(fundraiser: any) {
    this.selectedFundraisers = this.selectedFundraisers.filter((f: any) => f.fundraiserId !== fundraiser.fundraiserId);
    const existingFundraiserIds = this.selectedFundraisers.map((flag: any) => flag.fundraiserId);
    this.donationForm.get('fundraiserIds')?.setValue(existingFundraiserIds);
  }

  removeDonationFlag(flag: any): void {
    this.selectedDonationFlags = this.selectedDonationFlags.filter((f: any) => f.donationFlagId !== flag.donationFlagId);
    const existingFlagIds = this.selectedDonationFlags.map((flag: any) => flag.donationFlagId);
    this.donationForm.get('donationFlagIds')?.setValue(existingFlagIds);
  }

  showAdditionalFields() {
    console.debug('Additional fields logic here');
  }

  goToPreviousStep() {
    this.activeIndex--;
  }

  onSubmit() {
    // Use getRawValue() to include disabled controls
    console.debug('Form Submitted:', this.donationForm.getRawValue());
  }

  //openSettings() {
  //  console.debug('Open donor settings modal.');
  //  this.showDonorDedupeDialog = true;
  //}

  deleteDonor(event: any) {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Deleting donors is disabled.'
      });
      return;
    }

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to reset choosen donor?',
      header: 'Confirmation',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-outlined",
      accept: () => {
        this.showDonorInfo = false;
      },
      reject: () => {
        this.showDonorInfo = true;
      }
    });
  }

  addNewEvent(event: Event) {
    this.addEventDisplayModal = true;
    event.preventDefault();
    console.debug('Add New Event clicked.');
  }

  addNewFundraiser(event: Event) {
    this.addFundraiserDisplayModal = true;
    event.preventDefault();
    console.debug('Add New Fundraiser clicked.');
  }

  addDonation(event: any) {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Adding donations is disabled.'
      });
      return;
    }

    console.debug('Adding Donation!');
  }

  validateForm(): boolean {
    if (this.donationForm.invalid) {
      this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: 'Please fix validation errors before continuing to next step!' });
      console.debug(this.getInvalidControls(this.donationForm));
      return false;
    }
    return true;
  }

  saveDonation(mode: 'addNew' | 'exit'): void {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Saving is disabled.'
      });
      return;
    }

    // Use getRawValue() to include disabled controls
    const formValue = this.donationForm.getRawValue();
    console.debug('Saving donation:', formValue);
    if (this.validateForm()) {
      console.debug('Saving donation:', formValue);
      this.addDonationService.saveDonation(formValue).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Donation saved successfully!' });
          this.clearUnlockedFields();
          this.resetFormControls();
          this.addDonationStepper.activeStep = 0;

          if (mode === 'exit') {
            if (this.routeDonorId && this.navigationSource === 'donorCard') {
              this.router.navigate(['/vortex/donors/card', this.routeDonorId]);
            } else if (this.navigationSource === 'donationSearch') {
              this.router.navigate(['/vortex/donations/donation-search']);
            } else if (this.showHeader) {
              this.router.navigate([`/vortex/donations/edit-donation-batch/${this.batchId}`]);
            } else {
              this.activeIndex = 0;
              this.addDonationStepper.activeStep = 0;
              this.showDonorInfo = false;
            }
          } else if (mode === 'addNew' && this.showHeader) {
            this.refreshBatchHeader();
            this.activeIndex = 0;
            this.showDonorInfo = false;
          } else if (mode === 'addNew' && !this.showHeader) {
            this.activeIndex = 0;
            this.showDonorInfo = false;
          }
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Adding Donation!' });
        }
      });
    }
  }

  resetFormControls(): void {
    // Always preserve these fields
    const donorId = this.donationForm.get('donorId')?.value;
    const campaignId = this.donationForm.get('campaignId')?.value;
    const batchId = this.donationForm.get('batchId')?.value;

    // Determine if fundCode or eventCode are locked
    const fundCodeLocked = !!this.fieldLockStatus['fundCode'];
    const eventCodeLocked = !!this.fieldLockStatus['eventCode'];

    // Reset only unlocked fields, except donorId, campaignId, batchId
    Object.keys(this.donationForm.controls).forEach((key) => {
      // Skip always-preserved fields
      if (
        key === 'donorId' ||
        key === 'campaignId' ||
        key === 'batchId'
      ) {
        return;
      }

      // If fundCode is locked, skip resetting fundCodeId
      if (fundCodeLocked && key === 'fundCodeId') {
        return;
      }
      // If eventCode is locked, skip resetting eventCodeId
      if (eventCodeLocked && key === 'eventCodeId') {
        return;
      }

      // Only clear fundraisers if not locked
      if (['fundraiser', 'fundraiserIds'].includes(key)) {
        if (!this.fieldLockStatus['fundraiser']) {
          this.selectedFundraisers = [];
          this.donationForm.get('fundraiserIds')?.setValue([]);
        }
        return;
      }
      // Only clear donation flags if not locked
      if (['donationFlag', 'donationFlagIds'].includes(key)) {
        if (!this.fieldLockStatus['donationFlag']) {
          this.selectedDonationFlags = [];
          this.donationForm.get('donationFlagIds')?.setValue([]);
        }
        return;
      }

      // Otherwise, reset if not locked
      if (!this.fieldLockStatus[key]) {
        const control = this.donationForm.get(key);
        if (control) {
          // If the control is a boolean, set to false, else reset as usual
          const currentValue = control.value;
          if (typeof currentValue === 'boolean') {
            control.setValue(false);
          } else {
            control.reset();
          }
        }
      }
    });

    this.donationForm.get('isMasterDonation')?.setValue(null);

    // Restore preserved fields
    this.donationForm.get('donorId')?.setValue(donorId);
    this.donationForm.get('campaignId')?.setValue(campaignId);
    this.donationForm.get('batchId')?.setValue(batchId);

    this.isChildDonation = false;
    this.isParentDonation = false;
  }

  cancelDonation(): void {
    if (this.routeDonorId && this.navigationSource === 'donorCard') {
      this.router.navigate(['/vortex/donors/card', this.routeDonorId]);
    } else if (this.navigationSource === 'donationSearch') {
      this.router.navigate(['/vortex/donations/donation-search']);
    } else if (this.showHeader) {
      this.router.navigate([`/vortex/donations/edit-donation-batch/${this.batchId}`]);
    } else {
      this.resetFormControls();
      this.addDonationStepper.activeStep = 0;
      this.activeIndex = 0;
    }
  }

  goToNextStep(): void {
    if (this.validateForm()) {
      this.activeIndex++;
    }
  }

  toggleFieldLock(field: string): void {
    this.fieldLockStatus[field] = !this.fieldLockStatus[field];
    const control = this.donationForm.get(field);
    // Do not disable/enable always-enabled fields
    if (control && field !== 'donorId' && field !== 'campaignId' && field !== 'batchId') {
      if (this.fieldLockStatus[field]) {
        control.disable();
      } else {
        control.enable();
      }
    }

    // Disable donation flag autocomplete when locked
    if (field === 'donationFlag') {
      const donationFlagControl = this.donationForm.get('donationFlag');
      if (this.fieldLockStatus[field]) {
        donationFlagControl?.disable();
      } else {
        donationFlagControl?.enable();
      }
    }
  }

  onParentChildDonationChange(event: any): void {
    if (event.value === 'Child') {
      this.isChildDonation = true;
      this.isParentDonation = false;
      this.donationForm.get('isMasterDonation')?.setValue(false);
    } else if (event.value === 'Parent') {
      this.isChildDonation = false;
      this.isParentDonation = true;
      this.donationForm.get('isMasterDonation')?.setValue(true);
    } else {
      this.isChildDonation = false;
      this.isParentDonation = false;
      this.donationForm.get('isMasterDonation')?.setValue(null);
    }
  }

  onParentDonationTypeChange(event: any): void {
    console.debug(event);
    if (event.value === '2') {
      this.showPacLimitNotAffected = true;
    } else {
      this.showPacLimitNotAffected = false;
    }
  }

  private clearUnlockedFields(): void {
    Object.keys(this.fieldLockStatus).forEach((field) => {
      if (!this.fieldLockStatus[field]) {
        this.donationForm.get(field)?.reset();

        // Only clear fundraisers if not locked
        if (['fundraiser', 'fundraiserIds'].includes(field)) {
          if (!this.fieldLockStatus['fundraiser']) {
            this.selectedFundraisers = [];
            this.donationForm.get('fundraiserIds')?.setValue([]);
          }
          return;
        }
        // Only clear donation flags if not locked
        if (['donationFlag', 'donationFlagIds'].includes(field)) {
          if (!this.fieldLockStatus['donationFlag']) {
            this.selectedDonationFlags = [];
            this.donationForm.get('donationFlagIds')?.setValue([]);
          }
          return;
        }
      }
    });
  }

  onAmountInput(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const formattedValue = restrictToTwoDecimals(input.value);
    input.value = formattedValue;
    this.donationForm.get(controlName)?.setValue(formattedValue, { emitEvent: false });
  }

  openDonationFlagModal() {
    this.isEditDonationFlag = !!this.selectedDonationFlag;
    this.showDonationFlagModal = true;
  }

  onSaveDonationFlag(flag: any) {
    this.selectedDonationFlags.push({ name: flag.name }); 
    this.showDonationFlagModal = false; 
  }

  addNewDonationFlag(event: Event): void {
    this.showDonationFlagModal = true;
    event.preventDefault();
  }
}
